// extracted by mini-css-extract-plugin
export default {"leadManagement":"LeadManagement_leadManagement__Eb4W2","toolbar":"LeadManagement_toolbar__8A29M","mainPanel":"LeadManagement_mainPanel__oCoaa"};